module.exports = __webpack_public_path__ + "static/target.fc717f06.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/target.png
// module id = 819
// module chunks = 213628377533538